export const Constants = {};

export const Colors = {
  brandOne: "#0A3A5D",
  brandTwo: "#588EB5",
  brandTwoOpacity30: "#588EB54D",
  brandFive: "#DDE9F4",
  black: "#000000",
  white: "#FFFFFF",
  shark: "#22242C",
  prussianBlue: "#002855",
  gullGray: "#99A9BB",
  coolGrey: "#8E8EA1",
  coolGreyOpacity50: "#8E8EA180",
  red: "#B61F13",
  sharkOpacity10: "#22242C1A",
  brandFiveOpacity40: "#DDE9F466",
  sharkOpacity30: "#22242C4D",
  sharkOpacity20: "#22242C33",
  sharkOpacity60: "#22242C99",
  antiFlashWhite: "#f0f3f7",
  paleCornflowerBlueOpacity40: "#AEC8E766",
  fiord: "#49516F",
  wildSand: "#F4F4F4",
  boxShadow: "rgb(0 0 0 / 0.2)",
  iron: "#EAEAEB",
  altoOpacity5: "#D9D9D90D",
  alto: "#D9D9D9",
  pomegranate: "#B61F13",
  pomegranateOpacity10: "#B61F131A",
  gray: "#888888",
  blackPearl: "#06152B",
  brandFiveOpacity30: "#DDE9F44D",
  darkMint: "#346a90",
  whiteOpacity20: "#FFFFFF33",
  whiteOpacity10: "#FFFFFF0A",
  doveGray: "#666666",
  transparent: "transparent",
  darkBlue: "#163668",
  orange: "#E8B644",
  ash: "#FAFAFB",
  lightAsh: "#7C829B4A",
  greyAsh: "#191D234A",
  brightGray: "#EEEEEE",
  bombay: "#B6B7B9",
  sharkApprox: "#191D23",
  sharkApproxOpacity70: "#191D23B3",
  sharkApproxOpacity40: "#191D2366",
  blackOpacity10: "#0000001a",
  lightAshOpacity10: "#7C829B1A",
  martinique: "#33344F",
  martiniqueOpacity90: "#33344fe6",
  aquaHaze: "#f1f5f7",
  athensGray: "#e6e6e9",
  sharkOpacity80: "#191D23CC",
  sharkOpacity50: "#191D2380",
  lightGray: "#f5f5f5",
  brandFiveOpacity50: "#DDE9F480",
  brandFiveOpacity10: "#DDE9F41A",
  greenHaze: "#009656",
  sunsetOrange: "#FF4A55",
  skyBlue: "#72C4EC",
  amber: "#FFC200",
  blackPearlApprox: "#06151d",
  gray92: "#ebebeb",
  gray52: "#979797",
  brandTwoOpacity80: "#588EB5CC",
  gallery: "#EDEDED",
  linkWater: "#d7e3f3",
  ebonyClay: "#282e44",
  mediumCandyAppleRed: "#DF142D",
  spanishGray: "#999999",
  darkCharcoal: "#333333",
  emperor: "#525252",
  mineShaft: "#262626",
  bombayOpacity70: "#B6B7B9B3",
  bombayOpacity30: "#B6B7B94D",
  paleCornflowerBlue: "#AEC8E7",
  amberApprox: "#F8BD01",
  gray52Opcaity60: "#97979799",
  whiteOpacity40: "#FFFFFF66",
  firefly: "#0C202E",
  blackHaze: "#F5F6F6",
  silver: "#CCCCCC",
  fieryRed: "#B2000E",
  mariGoldorange: "#ED9254",
  flashyRed: "#D3281A",
  goldenYellow: "#FAAD14",
  mildGrey: "#F5F5F5",
  darkRed: "#831C14",
};

export const Text = {
  alreadyHaveAnAccountQ: "Already have an account?",
  annualTicketBalance: "Annual Ticket Balance",
  annualTicketBalanceHistory: "Annual Ticket Balance History",
  areYouSureYouWantToLogout: "Are you sure you want to logout?",
  areYouSureYouWantToCancelThisRequest:
    "Are you sure you want to cancel this request?",
  a4DigitCodeSent: "A 4-digit code has been sent to your mobile number ",
  back: "Back",
  cancel: "Cancel",
  cancelRequest: "Cancel Request",
  cancelTickets: "Cancel Request",
  changePin: "Change PIN",
  congratulations: "Congratulations!",
  continue: "Continue",
  continueToLogin: "Continue to Login",
  createAccount: "Create Account",
  createAFourDigitPin: "Create a four digit PIN",
  createAUniquePin:
    "Create a unique PIN to enable you to log in and reserve flights",
  details: "DETAILS",
  didntReceiveCodeQ: "Didn't recieve the code?",
  doYouHavePrivilegeCard: "Do you have a Privilege Card",
  dontHaveAnAccount: "Don't have an account?",
  dontHaveCompanyEmail: "Don't have a company Email?",
  dontHaveAnAccountError: "Dont have an account!",
  dontWorryEnterEmployeeId:
    "Don't worry! It happens. Please enter your employee ID to receive a verification code to your registered mobile number.",
  earliestExpiry: "Earliest Expiry ",
  elevateYourTravelExperience: "Elevate your travel experience!",
  email: "Email",
  employeeID: "Employee ID",
  enterComment: "Enter comment",
  enterEmployeeID: "Enter your employee ID",
  enteredReEnteredDontMatch: "Entered PIN and Re-entered PIN dont match!",
  enterMembershipNumber: "Enter membership number",
  enterNewPin: "Enter new PIN",
  enterOldPin: "Enter old PIN",
  enterPin: "Enter PIN",
  enterYourEmail: "Enter your email",
  enterYourPin: "Enter your PIN",
  enterVerificationCode: "Enter Verification code",
  fareSummary: "Fare Summary",
  findFlightHeaderText: "Find your flight",
  forgotPin: "Forgot PIN",
  forgotPinQ: "Forgot PIN?",
  getStarted: "Get Started",
  hideDetails: "Hide Details",
  iDontHavePrivilegeCard: "I don't have a Privilege Card.",
  letsGetOnYourWay: "Let's get you on your way!",
  letsStart: "Let's Start",
  login: "Login",
  loginWithEmployeeID: "Login with Employee ID",
  looksLikeAlreadyHaveAccountLogin:
    "Looks like you already have an account, please login!",
  networkError: "Network Error",
  newPinOldPin: "New PIN should not be same as old PIN.",
  noEntitlementHistory: "No Entitlement History",
  noTicketsAvailable: "No Tickets Available",
  ooops: "Ooops!",
  or: "OR",
  otp: "OTP",
  passengerDetailsText: "Passenger Details",
  pin: "PIN",
  pinChangeSuccessLogin: "PIN changed successfully. Please login!",
  pihEmployeesWithEmail: "Employees with Email",
  pleaseBookSelfPaid: "Please Book through Self Paid",
  pleaseCheckStatusOfRequest:
    "Please check the status of your request on the booking status page",
  pleaseContinueRegistration: "Please continue with the registration process!",
  pleaseLoginWithYourNewPin: "Please Login with your new PIN.",
  processCompletedSuccessfully: "Process completed successfully",
  qar: "QAR",
  reasonForCancellation: "Reason for Cancellation",
  reEnterNewPin: "Re-enter your new PIN",
  reEnterYourPin: "Re-enter your PIN",
  resendCode: "Re-send code",
  resetPin: "Reset PIN",
  resetYourPin: "Reset your PIN",
  retry: "Retry",
  seeYouSoon: "See you Soon!",
  selectFlight: "Select Flight",
  SelectGuestFlight: "Select Guest Flight",
  savePin: "Save PIN",
  send: "Send",
  setYourNewPin: "Set your new PIN so you can Login and book your flights.",
  signInAndUnlockYourTravelPlanswithUS:
    "Sign in and unlock your travel plans with us.",
  signUp: "Sign up",
  signUpAndDiscover: "Sign up and discover your next adventure with us!",
  sorrySomethingWentWrongPleaseTryAgain:
    "Sorry, something went wrong! Please try again.",
  stayOneStepAhead: "Stay one step ahead with a new, strong PIN.",
  submit: "Submit",
  success: "Success",
  takeMeToBookingStatusPage: "Take me to the booking status page!",
  thereWasAnErrorConnecting:
    "There was an error connecting, Please check your internet.",
  ticketIssuedOn: "Ticket issued on ",
  tryAgain: "Try again",
  updateYourPin: "Update your PIN",
  userExists: "User Exists!",
  validTill: "Valid till ",
  verifyAndResetPin: "Verify and Reset PIN",
  verifyAndCreatePin: "Verify and Create PIN",
  viewDetails: "View Details",
  welcomeBack: "Welcome back",
  welcomeBackYourJourneyContinues:
    "Welcome back, Your journey continues with us.",
  yesLogout: "Yes, Logout",
  yourAccountHasBeenCreated: "Your account has been created. ",
  yourAccountPinHasBeenSuccessfullyChanged:
    "Your account PIN has been successfully changed.",
  yourRequestSubmittedSuccessfully:
    "Your request has been submitted successfully.",
};

export const PROFILE_LISTINGS = [
  {
    label: "My Profile",
    iconPath: "profile",
    path: "/profile",
  },
  {
    label: "Change PIN",
    iconPath: "pin",
    path: "/pin",
  },
  // {
  //   label: "Entitlement History",
  //   iconPath: "entitlements",
  //   path: "/entitlements",
  // },
  {
    label: "FAQs",
    iconPath: "faqs",
    path: "/faqs",
  },
  {
    label: "Logout",
    iconPath: "logout",
    path: "/logout",
  },
];

export const NAVBAR_ITEMS = [
  {
    label: "Book Annual Trip",
    path: "dashboard",
  },
  {
    label: "Book Business Trip",
    path: "business",
  },
  {
    label: "Booking Status",
    path: "bookings",
  },
];

export const FLIGHT_RADIO_ITEMS = [
  {
    label: "One Way",
  },
  {
    label: "Round Trip",
  },
];

export const PAYMENT_TYPES = [
  {
    label: "Company Paid",
    value: "company paid",
  },
  {
    label: "Self Paid",
    value: "self paid",
  },
];

export const TRAVEL_CLASS = [
  {
    label: "Economy",
    value: "Economy",
  },
  {
    label: "Business",
    value: "Business Class",
  },
];

export const SAME_DATE = [
  {
    label: "Select",
    value: "",
  },
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];

export const REASON_FOR_CANCELLATION = [
  {
    label: "Select Reason",
    value: "",
  },
  {
    label: "Personal",
    value: "personal",
  },
  {
    label: "Change of Plan",
    value: "change of plan",
  },
  {
    label: "Illness",
    value: "illness",
  },
  {
    label: "Work conflict",
    value: "work conflict",
  },
  {
    label: "Family emergency",
    value: "family emergency",
  },
];

export const SIDEBAR_ITEMS = [
  {
    label: "Book Annual Trip",
    path: "dashboard",
  },
  {
    label: "Booking Status",
    path: "bookings",
  },
  {
    label: "Book Business Trip",
    path: "business",
  },
  {
    label: "My Profile",
    path: "profile",
  },
  {
    label: "Change PIN",
    path: "pin",
  },
  {
    label: "FAQs",
    path: "faqs",
  },
];

export const DESTINATION_COUNTRIES = [
  {
    label: "Select Country",
    value: "",
  },
  {
    label: "USA",
    value: "UnitedStates",
  },
  {
    label: "Australia",
    value: "Australia",
  },
  {
    label: "France",
    value: "France",
  },
  {
    label: "Brazil",
    value: "Brazil",
  },
  {
    label: "Germany",
    value: "Germany",
  },
  {
    label: "India",
    value: "India",
  },
];

export const BOOKING_INIT = {
  from: "",
  to: "",
  departureDate: new Date(),
  returnDate: new Date(Date.now() + 24 * 60 * 60 * 1000),
  returnTime: "",
  departureTime: "",
  perferAirline: [
    { label: "Srilankan Airlines", selected: false },
    { label: "Nepal Airlines", selected: false },
    { label: "Bangladesh Airlines", selected: false },
    { label: "Air India", selected: false },
    { label: "Egypt Air", selected: false },
    { label: "Philippines Airlines", selected: false },
    { label: "Indigo", selected: false },
    { label: "Turkish Airlines", selected: false },
    { label: "Royal Jordanian", selected: false },
    { label: "Air Cairo", selected: false },
    { label: "Emirates Airlines", selected: false },
    { label: "Kuwait Airways", selected: false },
    { label: "Pakistan Airlines", selected: false },
    { label: "Middle East Airlines", selected: false },
    { label: "Fly Dubai", selected: false },
    { label: "Saudi Airlines", selected: false },
    { label: "Qatar Airways", selected: false },
    { label: "Gulf Air", selected: false },
    { label: "Etihad Airlines", selected: false },
  ],
  directFlight: false,
  returnJourney: true,
};

export const EXCEPTIONAL_NATIONALITIES = [
  // "Syrian Arab Republic",
  "Palestine",
  // "Libya",
  "Ukraine",
  "Sudan",
];

export const BOOKING_STATUS = {
  new: "New",
  cancel: "Cancel",
  assigned: "Assigned",
  cancel_through_agent: "Cancelled By Agent",
  cancel_through_customer: "Cancelled By Customer",
  booked: "Booked",
  invoiced: "Closed",
  completed: "Closed",
  cancel_reverted: "Cancel And Reverted",
  requested_cancellation: "Requested Cancellation",
  requested_cancellation_revert: "Requested Cancellation",
  awaiting_clarification: "Awaiting Clarification",
  on_hold: "On Hold",
  invoice_error: "Booked",
  processing: "Leave Pending Approval",
  cancellation_pending_joury_approval: "Cancellation Pending Joury Approval",
  cancelled_full_refund: "Cancelled With Full Refund",
  cancelled_partial_refund: "Cancelled With Partial Refund",
  cancelled_non_refundable: "Cancelled Without Refund",
  cancelled: "Cancelled",

};

export const EXCEPTIONAL_NATIONALITIES_PRICE = {
  // "Syrian Arab Republic": {
  //   Economy: "1800",
  //   "Business Class": "4200",
  // },
  Palestine: {
    Economy: "2000",
    "Business Class": "4200",
  },
  // Libya: {
  //   Economy: "2000",
  //   "Business Class": "0",
  // },
  Ukraine: {
    Economy: "1900",
    "Business Class": "5000",
  },
  Sudan: {
    Economy: "2000",
    "Business Class": "0",
  },
};
